"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ConsoleAnalytics", {
  enumerable: true,
  get: function get() {
    return _ConsoleAnalytics["default"];
  }
});
Object.defineProperty(exports, "StorybookAnalytics", {
  enumerable: true,
  get: function get() {
    return _StorybookAnalytics["default"];
  }
});
Object.defineProperty(exports, "NullAnalytics", {
  enumerable: true,
  get: function get() {
    return _NullAnalytics["default"];
  }
});
exports["default"] = void 0;

var _analytics = _interopRequireDefault(require("./analytics"));

var _ConsoleAnalytics = _interopRequireDefault(require("./ConsoleAnalytics"));

var _StorybookAnalytics = _interopRequireDefault(require("./StorybookAnalytics"));

var _NullAnalytics = _interopRequireDefault(require("./NullAnalytics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _analytics["default"];
exports["default"] = _default;